import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { getAcceptedCategories } from '../consent-handling';

function createEventId() {
    // Older browsers and some embedded contexts may not expose crypto.randomUUID.
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function gtmCustomEvent(event: string, data: Record<string, any>) {
    try {
        TagManager.dataLayer({
            dataLayer: {
                event: event,
                event_id: createEventId(),
                ...data
            }
        });
    } catch (error) {
        console.warn('gtmCustomEvent failed:', error);
    }
}

export function useFirstPartyGtm(gtmId: string | undefined | null) {
    const { existingCategories } = getAcceptedCategories();
    useEffect(() => {
        if (!gtmId) {
            return;
        }

        if (!existingCategories.includes('targeting')) {
            // Consent not given, do not load GTM
            return;
        }

        const base = `${window.location.origin}/sgtm`;

        // Prevent double-inject
        const existing = document.querySelector<HTMLScriptElement>(
            `script[data-gtm="true"][data-gtm-id="${gtmId}"]`
        );
        if (existing) {
            return;
        }

        // Ensure dataLayer exists
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

        // Inject gtm.js from first-party endpoint
        const s = document.createElement('script');
        s.async = true;
        s.src = `${base}/gtm.js?id=${encodeURIComponent(gtmId)}&l=dataLayer`;
        s.setAttribute('data-gtm', 'true');
        s.setAttribute('data-gtm-id', gtmId);

        document.head.appendChild(s);
    }, [ gtmId, existingCategories ]);
}
